// this slice is using for upload pets images to Cloudinary

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { uploadToCloudinary } from "../../utils/uploadToCloudinary";

export const uploadPhoto = createAsyncThunk(
  "photoUpload/uploadPhoto",
  async (file, { rejectWithValue }) => {
    const maxSize = 8 * 1024 * 1024; 

    if (file.size > maxSize) {
      return rejectWithValue("too_large");
    }

    try {
      const imageUrl = await uploadToCloudinary(file);
      return imageUrl;
    } catch (err) {
      return rejectWithValue("upload_failed");
    }
  }
);

const photoUploadSlice = createSlice({
  name: "photoUpload",
  initialState: {
    uploading: false,
    error: null,
    photoUrl: null,
  },
  reducers: {
    clearPhotoUpload: (state) => {
      state.uploading = false;
      state.error = null;
      state.photoUrl = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadPhoto.pending, (state) => {
        state.uploading = true;
        state.error = null;
        state.photoUrl = null;
      })
      .addCase(uploadPhoto.fulfilled, (state, action) => {
        state.uploading = false;
        state.photoUrl = action.payload;
      })
      .addCase(uploadPhoto.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPhotoUpload } = photoUploadSlice.actions;
export const selectPhotoUpload = (state) => state.photoUpload;

export default photoUploadSlice.reducer;
